import React from 'react'

export default function Chart() {
  return (
    <div className='chart'>
      
      <img id='chart-img' src="https://ghchart.rshah.org/MUSSAFARA-RIAZ" alt="2016rshah's Github chart" />
    </div>
  )
}